export const employerPOCMappingTo790SectionII = {
  name: "Employer POC Form Mapping",
  machine_name: "employer_790_profile_mapping",
  targetFormDetailName: "Form ETA-790",
  targetSectionName: "Requestor Point-of-Contact</br> Information",
  targetSectionLabel: "II",
  fields: [
    {
      profileFieldName: "poc_emp_last_name",
      formTargetField: "eta_790_b3_poc_last"
    },
    {
      profileFieldName: "poc_emp_first_name",
      formTargetField: "eta_790_b4_poc_first"
    },
    {
      profileFieldName: "poc_emp_middle_name",
      formTargetField: "eta_790_b5_poc_middle"
    },
    {
      profileFieldName: "poc_emp_job_title",
      formTargetField: "eta_790_b6_poc_job_title"
    },
    {
      profileFieldName: "poc_emp_address1",
      formTargetField: "eta_790_b7_poc_address_1"
    },
    {
      profileFieldName: "poc_emp_address2",
      formTargetField: "eta_790_b8_poc_address_2"
    },
    {
      profileFieldName: "poc_emp_city", //missing from the form?
      formTargetField: "eta_790_b9_poc_city"
    },
    {
      profileFieldName: "poc_emp_country_id", //missing from the form?
      formTargetField: "pages[1].sections[1].fieldGroup.b10_poc_country_id"
    },
    {
      profileFieldName: "poc_emp_state_id",
      formTargetField: "eta_790_b10_poc_state_id"
    },
    {
      profileFieldName: "poc_emp_zip",
      formTargetField: "eta_790_b11_poc_zip"
    },
    {
      profileFieldName: "poc_emp_province", //missing from the form?
      formTargetField: "pages[1].sections[1].fieldGroup.b11_poc_province"
    },
    {
      profileFieldName: "poc_emp_phone",
      formTargetField: "eta_790_b12_poc_phone"
    },
    {
      profileFieldName: "poc_emp_phone_ext",
      formTargetField: "eta_790_b13_poc_phone_ext"
    },
    {
      profileFieldName: "poc_emp_email",
      formTargetField: "eta_790_b14_poc_email"
    }
  ]
};

export const employerMappingTo790SectionII = {
  name: "Employer Profile Form Mapping",
  machine_name: "employer_790_profile_mapping",
  targetFormDetailName: "Form ETA-790",
  targetSectionName: "Employer Information",
  targetSectionLabel: "II",
  fields: [
    {
      profileFieldName: "new_profile_emp_legal_name",
      formTargetField: "eta_790_b1_poc_name"
    },
    {
      profileFieldName: "new_profile_emp_dba",
      formTargetField: "eta_790_b2_poc_dba"
    },
    {
      profileFieldName: "new_profile_emp_fein",
      formTargetField: "eta_790_b15_poc_fein"
    },
    {
      profileFieldName: "new_profile_emp_naics_description",
      formTargetField: "eta_790_b16_poc_naics_description"
    },
    {
      profileFieldName: "new_profile_emp_naics",
      formTargetField: "eta_790_b16_poc_naics"
    },
  ]
};
